import * as Localization from "expo-localization";

export const getCountryCode = () => {
  const locales = Localization.getLocales();
  if (locales.length > 0) {
    const primaryLocale = locales[0];
    const { regionCode } = primaryLocale;

    return regionCode ? regionCode : "Worldwide";
  }
  return "Worldwide";
};
